import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ConciergeColorIcon = _ref => {
  let {
    size,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: rem(size),
    height: rem(size)
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#233844",
    d: "M388.6 224.8v85.7L366.2 294l-69.8 214.8C418.6 489.4 512 383.6 512 256a255.17 255.17 0 0 0-74.8-180.8zM122.6 310.5v-88L74.8 75.2A255.17 255.17 0 0 0 0 256c0 127.6 93.4 233.4 215.6 252.8l-69.9-215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.6 78.4l133 96.6.4-.3V0A254.86 254.86 0 0 0 74.8 75.2l47.8 147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.2 253l79.7-58.6-79.7-58.5V253zM242.3 445a14 14 0 0 1 13.7-14v-52.3a14 14 0 0 1 0-28v-52.3a14 14 0 0 1 0-28v-57.5l-.4-.3-110 80.9 69.9 215.3a257.06 257.06 0 0 0 40.4 3.2v-53a14 14 0 0 1-13.6-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M388.6 78.4v146.4l48.6-149.6A254.86 254.86 0 0 0 256 0v174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M359.1 253V135.9l-79.8 58.5 79.8 58.6zM256 212.9v57.5h.3a14 14 0 1 1 0 28h-.3v52.3h.3a14 14 0 0 1 0 28h-.3V431h.3a14 14 0 0 1 0 28h-.3v53a256.11 256.11 0 0 0 40.4-3.2L366.2 294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee684d",
    d: "M256 174.7l-.4.3-133-96.6v232.2l23.1-17 110-80.9.4.3 110.2 81 22.5 16.5V78.4zM152.2 253V136l79.7 58.5zm206.9 0l-79.7-58.5 79.7-58.5v117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233844",
    d: "M242.3 284.5a14 14 0 0 0 13.7 14h.3a14 14 0 0 0 0-28h-.3a14 14 0 0 0-13.7 14zM242.3 364.7a14 14 0 0 0 13.7 14h.3a14 14 0 0 0 0-28h-.3a14 14 0 0 0-13.7 14zM242.3 445a14 14 0 0 0 13.7 14h.3a14 14 0 0 0 0-28h-.3a14 14 0 0 0-13.7 14z"
  }));
};
ConciergeColorIcon.defaultProps = {
  size: 16
};
export default ConciergeColorIcon;